export const pageRailStyles = {
  position: 'sticky',
  top: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  minWidth: 0,
};

export const pageButtonStyles = {
  justifyContent: 'space-between',
  gap: '8px',
};
